<div class="dialog-agent">
  <h1 mat-dialog-title>{{ 'GLOBAL.APPLY-CHANGES' | translate }}</h1>
  <div mat-dialog-content class="">
    {{ 'GLOBAL.ARE-YOU-SURE-APPLY' | translate }}
  </div>
  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [mat-dialog-close]="true">
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.YES' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" (click)="onNoClick()">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.NO' | translate }}</span>
    </button>
  </div>
</div>
